export default "__VITE_ASSET__Uo87hoZe__"